export default __webpack_public_path__ + "static/effortsImg-0ce68e48c28f7a6005462c4f8e7ed875.png";